<template>
	<div class="template date-range">
		<div class="panel_wrap">
			<div class="file-wrap-title">开始时间<span v-show="dataVal.require" class="require">*</span> </div>
			<div class="input_value">
				<el-date-picker v-model="dataVal.start" align="right" style="width: 100%;" type="date" placeholder="选择日期时间"></el-date-picker>
			</div>
		</div>
		<div class="panel_wrap">
			<div class="file-wrap-title">结束时间<span v-show="dataVal.require" class="require">*</span> </div>
			<div class="input_value">
				<el-date-picker v-model="dataVal.end" align="right" style="width: 100%;" type="date" placeholder="选择日期时间"></el-date-picker>
			</div>
		</div>
		<div class="panel_wrap">
			<div class="file-wrap-title">时长<span v-show="dataVal.require" class="require">*</span> </div>
			<div class="input_value">
				{{dataVal.time_difference}}
				<span class="unit">天</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dataVal']
	}
</script>

<style>
	@import "../../assets/css/common.css";
	
	.panel_wrap .el-input__prefix {
		display: none !important;
	}

	.el-input--suffix .el-input__inner {
		/* padding-right: 0 !important; */
	}
</style>
